import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import { sublace, formatNumber, plural } from '../../common/sublace';
import { overview } from '../states/overview';
export function assetUrl(path) {
  return (app.forum.attribute('assetsBaseUrl') || '/assets') + '/extensions/sublace-forum/' + path;
}

/** Баннер главной: название, описание, IP сервера и Discord. */
export default class SublaceHero extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.copied = false;
  }
  view() {
    const config = sublace();
    const data = overview();
    const online = data && data.online ? data.online.total : null;
    return m("header", {
      className: "SublaceHero"
    }, m("div", {
      className: "container SublaceHero-inner"
    }, m("div", {
      className: "SublaceHero-text"
    }, m("div", {
      className: "SublaceHero-eyebrow"
    }, m("span", {
      className: "SublaceHero-dot"
    }), " \u041E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0444\u043E\u0440\u0443\u043C", online !== null ? m("span", {
      className: "SublaceHero-online"
    }, "\xB7 ", formatNumber(online), " ", plural(online, 'участник', 'участника', 'участников'), " \u043E\u043D\u043B\u0430\u0439\u043D") : null), m("h1", {
      className: "SublaceHero-title"
    }, config.heroTitle || app.forum.attribute('title')), config.heroText ? m("p", {
      className: "SublaceHero-description"
    }, config.heroText) : null, m("div", {
      className: "SublaceHero-actions"
    }, config.serverIp ? m("button", {
      className: "SublaceHero-ip",
      type: "button",
      onclick: () => this.copyIp(config.serverIp),
      title: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C IP \u0441\u0435\u0440\u0432\u0435\u0440\u0430"
    }, m(Icon, {
      name: "fas fa-server"
    }), m("span", {
      className: "SublaceHero-ipValue"
    }, config.serverIp), m("span", {
      className: "SublaceHero-ipHint"
    }, this.copied ? 'Скопировано' : 'Скопировать')) : null, config.discordUrl ? m("a", {
      className: "Button SublaceButton SublaceButton--discord",
      href: config.discordUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, m(Icon, {
      name: "fab fa-discord"
    }), " Discord") : null, config.siteUrl ? m("a", {
      className: "Button SublaceButton SublaceButton--ghost",
      href: config.siteUrl,
      target: "_blank",
      rel: "noopener noreferrer"
    }, m(Icon, {
      name: "fas fa-globe"
    }), " \u0421\u0430\u0439\u0442 \u043F\u0440\u043E\u0435\u043A\u0442\u0430") : null)), m("div", {
      className: "SublaceHero-art",
      "aria-hidden": "true"
    }, m("div", {
      className: "SublaceHero-glow"
    }), m("img", {
      src: assetUrl('img/mark-256.webp'),
      alt: "",
      width: "220",
      height: "220"
    }))));
  }
  copyIp(ip) {
    const done = () => {
      this.copied = true;
      m.redraw();
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.copied = false;
        m.redraw();
      }, 2000);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(ip).then(done, () => this.fallbackCopy(ip, done));
    } else {
      this.fallbackCopy(ip, done);
    }
  }
  fallbackCopy(ip, done) {
    const input = document.createElement('textarea');
    input.value = ip;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      done();
    } catch (e) {
      app.alerts.show({
        type: 'error'
      }, 'Не удалось скопировать. IP: ' + ip);
    }
    document.body.removeChild(input);
  }
  onremove(vnode) {
    super.onremove(vnode);
    clearTimeout(this.timer);
  }
}
flarum.reg.add('sublace-forum', 'forum/components/SublaceHero', SublaceHero);